/**
 * Erkennung von Lazy-Chunk-Ladefehlern nach einem Deploy (reine Funktion, §10).
 *
 * Hintergrund: index.html referenziert fingerprinted Chunks. Hat ein Browser
 * die App noch von vor einem Deploy offen, fordert er beim Navigieren einen
 * alten Chunk-Hash an. Der Server liefert dafür den SPA-Fallback (HTML) bzw.
 * 404 — der dynamische Import wirft. Einmaliges Neuladen holt das frische
 * index.html und behebt den Zustand.
 */
export function isChunkLoadError(error: unknown): boolean {
  const message =
    error instanceof Error
      ? `${error.name} ${error.message}`
      : typeof error === 'string'
        ? error
        : '';
  return (
    /failed to fetch dynamically imported module/i.test(message) ||
    /error loading dynamically imported module/i.test(message) ||
    /importing a module script failed/i.test(message) ||
    /'text\/html' is not a valid javascript mime type/i.test(message) ||
    /failed to load module script/i.test(message)
  );
}

const RELOAD_FLAG = 'proerp:chunk-reload';

/** True genau einmal je Sitzung — verhindert Reload-Schleifen. */
export function shouldReloadOnce(storage: Pick<Storage, 'getItem' | 'setItem'>): boolean {
  if (storage.getItem(RELOAD_FLAG)) return false;
  storage.setItem(RELOAD_FLAG, String(Date.now()));
  return true;
}

/** Nach erfolgreichem Laden wieder freigeben (nächster Deploy darf wieder heilen). */
export function clearReloadFlag(storage: Pick<Storage, 'removeItem'>): void {
  storage.removeItem(RELOAD_FLAG);
}
